<template>
	<router-link @click="$scrollToTop" to="/g/1" id="game-btn" aria-current="page" class="d-none d-lg-block nav-link game-btn text-nowrap" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" :data-bs-title="`<div class='tooltip-body'>${ $t('games.topmenutooltip', 'Play our game Land of Titans and learn game design by doing, not just watching. Play the First Level Free') }</div>`">{{ $t('games.topmenucta', 'Play & Learn') }}</router-link>
	<div id="game-btn" role="button" aria-current="page" class="d-lg-none nav-link game-btn text-nowrap" data-bs-html="true" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-custom-class="custom-tooltip" :data-bs-title="`<div class='tooltip-body'>${ $t('games.topmenutooltipm', 'Desktop version is availabe. Please, use your desktop computer') }</div>`">{{ $t('games.topmenucta', 'Play  & Learn') }}</div>
</template>
<script lang="ts" setup>
import { onMounted, watch, nextTick } from 'vue';
import { Tooltip } from 'bootstrap';
import { userLangStore } from '@/store/userLangStore';

const lang = userLangStore();

watch(() => lang.refreslang, async () => {
	await nextTick();
	initTooltip();
});

onMounted(
	async () => {
		initTooltip();

	});

function initTooltip() {
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
	[...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
}
</script>
<style scopped lang="scss">
.nav-link.game-btn {
	border: solid 1px var(--tt-1)!important;
	border-radius: 12px 0px 12px 12px;
}

#app .maintop.sticky .nav-link.game-btn {
	@media (max-width: 992px) {
		color: #fff!important;
	}
}

#app .maintop .navbar-collapse .nav-link.game-btn:hover  {
	border-bottom: solid 1px var(--tt-1)!important;
}

.custom-tooltip {
	--bs-tooltip-bg: var(--tt-1)!important;
	--bs-tooltip-color: var(--bs-white)!important;
	--bs-tooltip-opacity: .99!important;
}

.custom-tooltip.tooltip > .tooltip-inner {
    max-width: 400px;
}

.tooltip-body {
	padding: 20px;
	font-family: play;
	font-weight: 500;
	font-size: 16px;
}
</style>